// KUMAŞSIZ STOR REÇETESİ — SAF MANTIĞIN TEK KAYNAĞI
// Spec: docs/superpowers/specs/2026-10-31-kumasizsiz-stor-recete-design.md
//
// FİYATLAR KODA GÖMÜLMEZ: mekanizma/zincir/ayak/işçilik Fiyat Kalemleri'nden
// (priceItems: code/basePrice/currency), motor/kumanda Varlıklar'dan (assets:
// kind motor|control, groupSlugs "stor_sistem") okunur.
//
// KURALLAR (reçete birebir):
// - Genişlik: 10 cm adıma yuvarla; artık 2 cm'den azsa AŞAĞI, değilse yukarı;
//   min 100 cm.
// - Motorlu sistemde motor ZORUNLU; motor min genişlik 60 cm (ham ölçü).
// - Kumanda: n=1 → 1× Tek Kanal; n≥2 → ⌈n/6⌉ × 6 Kanal.
// - Fiyat bulunamayan bileşen satırı EKLENMEZ, uyarı errors'a yazılır;
//   mekanizma fiyatı yoksa ana satır toplamı null (0 fiyat DEĞİL — İsk-3).

const r2 = (x) => Math.round(x * 100) / 100;

export function roundRecipeWidth(w) {
  const n = Number(w) || 0;
  const r = n % 10;
  const rounded = r < 2 ? n - r : n + (10 - r);
  return Math.max(100, rounded);
}

export function kumandaPlan(n) {
  const m = Number(n) || 0;
  if (m <= 0) return null;
  if (m === 1) return { code: "KS-KUMANDA-TEK", qty: 1 };
  return { code: "KS-KUMANDA-6", qty: Math.ceil(m / 6) };
}

export function findPriceItem(priceItems, code) {
  const it = (priceItems || []).find((p) => p && p.code === code);
  return it ? { basePrice: Number(it.basePrice) || 0, currency: it.currency, unit: it.unit, name: it.name } : null;
}

export function findMotorAsset(assets, name) {
  const a = (assets || []).find((x) => x &&
    (x.kind === "motor" || x.kind === "control") &&
    (Array.isArray(x.groupSlugs) && x.groupSlugs.includes("stor_sistem")) &&
    ((x.label || x.name || "").trim() === String(name || "").trim()));
  return a ? { price: Number(a.price) || 0, currency: a.currency, label: a.label || a.name } : null;
}

// Reçete eşlemesi — fiyat kalemi KODLARI (değerler değil; fiyatlar listeden okunur)
export const RECIPE_CODES = {
  mekanizma: {
    manuel: { "Kapalı Kasa": "KS-STOR32-KAPALI", "Açık Kasa": "KS-STOR32-ACIK" },
    motorlu: { "Kapalı Kasa": "KS-STOR47-KAPALI", "Açık Kasa": "KS-STOR47-ACIK" },
  },
  ayak: { manuel: "KS-AYAK-MANUEL", motorlu: "KS-AYAK-MOTORLU" },
  iscilik: { manuel: "KS-ISCILIK-MANUEL", motorlu: "KS-ISCILIK-MOTORLU" },
  zincir: { "Metal Zincir": "KS-ZINCIR-KROM", "Plastik Zincir": "KS-ZINCIR-PLASTIK" },
};

// Kumanda satırının Varlık adları — kumandaPlan kod eşlemesi (fiyatlar Varlıklar'dan)
export const KUMANDA_ASSET_NAMES = {
  "KS-KUMANDA-TEK": "Reavista Kumanda Tek Kanal",
  "KS-KUMANDA-6": "Reavista Kumanda 6 Kanal",
};

// Silme = vazgeçme bayrağı — teklif kaydında yaşar (spec: "geri eklenmez")
export function isKumandaOptOut(quote) {
  return Boolean(quote && (quote.kumandaOptOut === true || quote.kumandaOptOut === "true"));
}

const isAutoKumanda = (it) => !!(it && it.groupSlug === "stor_sistem_acc" && it.isKumandaAuto === true);
const isStorMotor = (it) => !!(it && it.groupSlug === "stor_sistem_acc" &&
  (it.kind === "motor" || ["Reavista Elektrikli", "Reavista Şarjlı"].includes(String(it.product || "").trim())));

// OTOMATİK KUMANDA SATIRI — SİPARİŞ BAZINDA (31.10)
// Sepetteki yalnız kumaşsız stor motorları sayılır (n); kural:
//   n = 1 → 1× Reavista Kumanda Tek Kanal; n ≥ 2 → ⌈n/6⌉ × Reavista Kumanda 6 Kanal.
// - Eski otomatik satır temizlenip kurala göre yeniden kurulur; son motor satırının
//   bileşen bloğu sonrasına yerleşir.
// - `optOut: true` → satır eklenmez (kullanıcı silmişse "kumanda istemiyorum").
// - Aynı satır birebir aynıysa dokunulmaz (changed: false — idempotent).
// - Fiyat bulunamazsa satır EKLENMEZ (spec: eklenmez/uyarı).
export function applyKumandaRule(items, opts = {}) {
  const { optOut = false, assets = [] } = opts;
  const original = items || [];
  const prevAuto = original.find(isAutoKumanda) || null;
  const stripped = original.filter((it) => !isAutoKumanda(it));

  const n = stripped.filter(isStorMotor).reduce((s, it) => s + (Number(it.qty) || 1), 0);
  const plan = kumandaPlan(n);
  const removedAny = stripped.length !== original.length;

  if (optOut || !plan) {
    return { items: stripped, changed: removedAny, warning: null };
  }

  const name = KUMANDA_ASSET_NAMES[plan.code];
  const asset = findMotorAsset(assets, name);
  if (!asset || !(asset.price > 0)) {
    // Fiyat bulunamazsa satır EKLENMEZ — ama sessiz de kalınmaz (uyarı döner)
    return { items: stripped, changed: removedAny,
             warning: `${name} fiyatı bulunamadı — kumanda satırı eklenmedi` };
  }
  const row = {
    groupSlug: "stor_sistem_acc",
    kind: "kumanda",
    product: name,
    unit: "adet",
    qty: plan.qty,
    unitPrice: asset.price,
    lineTotal: r2(asset.price * plan.qty),
    currency: asset.currency,
    kdvRate: 20,
    isAccessory: true,
    isKumandaAuto: true,
  };

  const same = prevAuto && prevAuto.product === row.product && Number(prevAuto.qty) === row.qty
    && Number(prevAuto.unitPrice) === row.unitPrice && Number(prevAuto.lineTotal) === row.lineTotal
    && prevAuto.currency === row.currency;
  if (same) {
    return { items: original, changed: false, warning: null };
  }

  const out = stripped.slice();
  let insertAt = out.length;
  for (let i = out.length - 1; i >= 0; i--) {
    if (isStorMotor(out[i])) { insertAt = i + 1; break; }
  }
  out.splice(insertAt, 0, row);
  return { items: out, changed: true, warning: null };
}

// DÜZENLEME MODU — blok yeniden kurulumu (31.10, Review Focus #4)
// items[index] = mainRow olarak değiştirilir; index'ten SONRA gelen bitişik
// aksesuar bloğu (eski bileşenler + eski otomatik kumanda) temizlenir, compRows
// yenisi olarak kurulur ve kumanda kuralı yeniden çalışır → kalıntı KALMAZ.
export function replaceStorItem(items, index, mainRow, compRows, opts = {}) {
  const list = items || [];
  const drop = new Set();
  for (let j = index + 1; j < list.length && list[j]?.isAccessory; j++) drop.add(j);
  const base = list.filter((_, idx) => !drop.has(idx));
  if (index >= 0 && index < base.length) base[index] = mainRow;
  const merged = [...base.slice(0, index + 1), ...(compRows || []), ...base.slice(index + 1)];
  const res = applyKumandaRule(merged, opts);
  return { items: res.items, warning: res.warning, removedCount: drop.size };
}

export function validateStorSistemDraft(draft) {
  const errs = [];
  const d = draft || {};
  if (!d.kasaTipi) errs.push("Kasa tipi seçilmeli");
  if (!(Number(d.widthCm) > 0)) errs.push("Genişlik gerekli");
  if (d.sistem === "motorlu") {
    if (!d.motorName) errs.push("Motorlu sistemde motor seçilmeli (Reavista Elektrikli / Reavista Şarjlı)");
    if (Number(d.widthCm) > 0 && Number(d.widthCm) < 60) errs.push("Motorlu sistemde en az 60 cm genişlik gerekli");
  }
  return errs;
}

export function buildStorSistemComponents(draft, priceItems, assets) {
  const d = draft || {};
  const errors = [];
  const qty = Math.max(1, Number(d.qty) || 1);
  const sistem = d.sistem === "motorlu" ? "motorlu" : "manuel";
  const roundedW = roundRecipeWidth(d.widthCm);
  const mt = roundedW / 100;

  // 1) Ana satır — mekanizma (mt × reçete fiyatı × adet), TL
  const mekCode = (RECIPE_CODES.mekanizma[sistem] || {})[d.kasaTipi];
  const mek = mekCode ? findPriceItem(priceItems, mekCode) : null;
  // Spec §5.1: ürün adında sistem tipi görünür (manuel/motorlu satırlar ayırt edilebilsin)
  const sistemLabel = sistem === "motorlu" ? "Motorlu (47Ø)" : "Manuel (32Ø)";
  // MT KOD GELENEĞİ (K6): ana satırda qty = TOPLAM METRE (mt × adet) — müşteri
  // metre bazlı mekanizmada "2,20 mt" görür, "m²" DEĞİL.
  const mtTotal = r2(mt * qty);
  const main = {
    product: `Kumaşsız Stor Sistemi · ${sistemLabel} · ${d.kasaTipi || "?"}`,
    unit: "mt",
    qty: mtTotal,
    pieceQty: qty,
    unitPrice: null,
    lineTotal: null,
    roundedW,
    mt,
    currency: "TL",
    kdvRate: null, // ana satır kdv'si ürün grubunun defaultKdv'si (çağrıcı uygular)
  };
  if (!mek || !(mek.basePrice > 0)) {
    errors.push(`Mekanizma fiyatı bulunamadı (${mekCode || d.kasaTipi}) — fiyat kalemi eksik`);
  } else {
    main.unitPrice = mek.basePrice;
    main.lineTotal = r2(mtTotal * mek.basePrice);
  }

  // 2) Bileşen satırları — fiyat bulunamayan EKLENMEZ, uyarı errors'a
  const components = [];
  const push = (kind, codeOrName, unit, price, currency, label) => {
    components.push({
      kind,
      product: label,
      unit,
      qty,
      unitPrice: price,
      lineTotal: r2(price * qty),
      currency,
      kdvRate: 20,
      isAccessory: true,
    });
  };
  const addPriceItem = (kind, code, unit) => {
    const p = findPriceItem(priceItems, code);
    if (!p || !(p.basePrice > 0)) {
      // Spec karar #5 + anti-hedef: fiyatı girilmemiş/sıfır bileşen satırı
      // EKLENMEZ — 0 TL'lik satır müşteri teklifine girmez; uyarı yazılır.
      errors.push(`${p ? p.name : code} fiyatı girilmemiş — satır eklenmedi`);
      return;
    }
    push(kind, code, unit, p.basePrice, p.currency, p.name);
  };

  const zincirCode = RECIPE_CODES.zincir[d.zincirTipi || "Metal Zincir"];
  addPriceItem("zincir", zincirCode, "adet");
  addPriceItem("ayak", RECIPE_CODES.ayak[sistem], "adet");
  addPriceItem("iscilik", RECIPE_CODES.iscilik[sistem], "adet");

  if (sistem === "motorlu") {
    const m = findMotorAsset(assets, d.motorName);
    if (!m || !(m.price > 0)) {
      errors.push(`Motor fiyatı bulunamadı (${d.motorName || "?"}) — satır eklenmedi`);
    } else {
      push("motor", d.motorName, "adet", m.price, m.currency, m.label);
    }
  }

  return { main, components, errors };
}
